// src/components/RPA/buttons/UploadBankConfirmationButton.js
// ✅ FIXED - Bank Confirmation Upload (Step 10) - Correct API Route
import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API || 'http://localhost:8000';

const UploadBankConfirmationButton = ({ docId, disabledHint, onDone }) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const downloadTemplate = () => {
    const csv = `Bank Name,Account Number,Account Type,Balance Date,Confirmed Balance,Confirmation Date,Signatory Name,Signatory Title,Bank Address,Confirmation Number,Confirmation Method
First National Bank,****1234,Checking,12/31/2024,12450000,01/15/2025,John Smith,VP Treasury Operations,"123 Main St, Washington DC 20001",BCL-2025-001234,email`;
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Bank_Confirmation_Template.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Please select a file');
      return;
    }

    if (!docId) {
      setError('No document ID provided');
      return;
    }

    setUploading(true);
    setError(null);

    const formData = new FormData();
    formData.append('bankConfirmation', file);

    try {
      // ✅ FIXED: Use correct route pattern /admin/rpa/docs/${docId}/bank-confirmations/upload
      const res = await axios.post(
        `${API_URL}/admin/rpa/docs/${docId}/bank-confirmations/upload`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          withCredentials: true
        }
      );
      console.log('[BANK_CONF] Success:', res.data);
      setResult(res.data);
      if (onDone) setTimeout(onDone, 2000);
    } catch (err) {
      console.error('[BANK_CONF] Error:', err);
      setError(err.response?.data?.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ padding: '20px', background: '#f8f9fa', borderRadius: '8px' }}>
      <h4 style={{ marginTop: 0, color: '#2c3e50' }}>📧 Bank Confirmations (Step 10)</h4>
      <p style={{ fontSize: '14px', color: '#6c757d' }}>
        Upload external bank confirmation letters. Provides strongest audit evidence for cash existence.
      </p>

      {disabledHint && (
        <div style={{ padding: '10px', background: '#fff3cd', borderRadius: '6px', marginBottom: '12px', fontSize: '14px' }}>
          ⚠️ {disabledHint}
        </div>
      )}

      <button 
        onClick={downloadTemplate} 
        style={{ 
          padding: '8px 16px', 
          background: '#6c757d', 
          color: 'white', 
          border: 'none', 
          borderRadius: '6px', 
          marginBottom: '12px', 
          cursor: 'pointer',
          fontSize: '14px'
        }}
      >
        📄 Download Template
      </button>

      <input 
        type="file" 
        accept=".csv,.txt" 
        onChange={(e) => { setFile(e.target.files[0]); setError(null); setResult(null); }} 
        disabled={!!disabledHint || uploading} 
        style={{ display: 'block', marginBottom: '12px' }} 
      />

      {file && (
        <div style={{ padding: '8px', background: '#e7f3ff', borderRadius: '4px', marginBottom: '12px', fontSize: '13px' }}>
          📎 {file.name}
        </div>
      )}

      <button 
        onClick={handleUpload} 
        disabled={!file || uploading || !!disabledHint} 
        style={{ 
          padding: '12px 24px', 
          background: !file || uploading || disabledHint ? '#ccc' : '#28a745', 
          color: 'white', 
          border: 'none', 
          borderRadius: '6px', 
          cursor: !file || uploading || disabledHint ? 'not-allowed' : 'pointer', 
          fontWeight: '600',
          fontSize: '15px',
          width: '100%'
        }}
      >
        {uploading ? '⏳ Uploading Bank Confirmations...' : '✅ Upload Bank Confirmations'}
      </button>

      {error && (
        <div style={{ marginTop: '12px', padding: '12px', background: '#f8d7da', color: '#721c24', borderRadius: '6px', fontSize: '14px' }}>
          ❌ {error}
        </div>
      )}
      
      {result && (
        <div style={{ marginTop: '12px', padding: '12px', background: '#d4edda', color: '#155724', borderRadius: '6px' }}>
          <strong>✅ Bank Confirmations Uploaded Successfully!</strong>
          <div style={{ marginTop: '8px', fontSize: '13px' }}>
            • Confirmations: {result.summary?.totalConfirmations || 0}<br/>
            • Reconciled: {result.summary?.reconciledCount || 0}<br/>
            • Exceptions: {result.summary?.exceptionCount || 0}<br/>
            • Bank Balance: ${(result.summary?.totalBankBalance || 0).toLocaleString()}
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadBankConfirmationButton;